<template>
  <div id="ospitalita">
    <!--    <event-modal img="../../static/image/pop-up-quvestra.jpg" :title="'Sospensione Attività'"></event-modal>-->
    <room-slider></room-slider>
    <div id="scatola">
      <div class="col-lg-12 indirizzo">
        <router-link :to="{name: 'homepage'}">Home</router-link>
        / {{$t("hospitality")}}
      </div>
      <div class="row col-lg-12 box" id="result" v-for="(camera, index) in camere" v-bind:key="index">
        <div class="col-xl-6 col-lg-12 foto">
          <b-carousel :id="'carousell'+camera.id"
                      style="text-shadow: 1px 1px 2px #333; display: table-cell"
                      controls
                      indicators
                      background="#ababab"
                      :interval="0"
                      img-width="300"
                      img-height="300"
                      @sliding-start="onSlideStart"
                      @sliding-end="onSlideEnd">
            <!-- Slides with image only -->
            <b-carousel-slide fluid-grow v-for="i in rooms[camera.image].numFoto" v-bind:key="camera.image+i"
                              :img-src="'static/image/rooms/' + camera.image + '/' + i + '.jpg'">
            </b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-xl-6 col-lg-12 titoloevento">
          <span>Alloggio {{camera.name}}<br>
                  <span v-if="['111', '112', '201', '202'].some(n => camera.name.toLowerCase().includes(n))">
                    (comunicante)
                  </span>
          </span><br>
          <!--          <span v-if="camera.price !== 0">{{camera.price}} &euro; / notte</span>-->
          <!--          <span v-else>{{mexage}}</span>-->
          <div>
            <img src="../../static/image/PISCI.png" class="iconcamera" alt="Piscina inclusa"/>
            <img src="../../static/image/wifi.png" class="iconcamera" alt="Free wi-fi"/>
            <img src="../../static/image/BIANC.png" class="iconcamera" alt="Biancheria inclusa"/>
            <div class="descrizioneevento">
              <div><img class="iconservice" src="../../static/image/rooms/postiLetto.png"/><span class="dettagli">Posti letto: {{camera.posti}}&emsp;</span></div>
              <!--<div><img class="iconservice" src="../../static/image/rooms/camere.png"/><span class="dettagli">Camere: {{camera.singole + camera.doppie + camera.triple}}&emsp;</span></div>-->
              <div><img class="iconservice" src="../../static/image/rooms/wc.png"/><span class="dettagli">Bagni: {{camera.bagno + camera.wc}}&emsp;</span></div>
              <div><img class="iconservice" src="../../static/image/rooms/cucina.png"/><span class="dettagli">Cucine: {{camera.cucina}}&emsp;</span></div>
            </div>
          </div>
          <div>  {{$t("info")}}  <a href="mailto:info@tenutaballerio.com" style="text-decoration: underline"> info@tenutaballerio.com</a></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderPage from './HeaderPage'
import Footer from './Footer'
import RoomSlider from './RoomSlider'
import moment from 'moment'
import ModalCovid from "./global/EventModal";
import EventModal from "./global/EventModal";

export default {
  name: 'ospitalita',
  components: {EventModal, ModalCovid, RoomSlider, Footer, HeaderPage},
  data() {
    return {
      mexage: 'Richiedi un preventivo',
      camere: [],
      slide: 0,
      sliding: null,
      ordineCamere: ['BORDO', 'RENAN', 'COMUNI', 'PARVA3', 'PARVA4', 'MAGNA4', 'MAGNA8', 'VILLA'],
      rooms: {
        MAGNA8: {
          numFoto: 11
        },
        BORDO: {
          numFoto: 7
        },
        MAGNA4: {
          numFoto: 8
        },
        COMUNI: {
          numFoto: 9
        },
        RENAN: {
          numFoto: 8
        },
        VILLA: {
          numFoto: 16
        },
        PARVA3: {
          numFoto: 5
        },
        PARVA4: {
          numFoto: 3
        },
      },
      form: {
        dateFrom: this.$route.params.dateFrom,
        dateTo: this.checkRouterParams(),
        people: 1
      },
      rules: {
        dateFrom: [
          {type: 'date', required: true, message: 'Scegli la data di arrivo', trigger: 'change'}
        ],
        dateTo: [
          {type: 'date', required: true, message: 'Scegli la data di partenza', trigger: 'change'}
        ]
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      pickerOptions2: null,
      listCamere: [{
        "id": "BORDO",
        "name": "Villa  Pinot 102",
        "maxSize": 2,
        "basePrice": 50.0,
        "price": 45.0,
        "image": "BORDO",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 2,
        "singole": 0,
        "doppie": 1,
        "triple": 0,
        "bagno": 1,
        "wc": 0,
        "cucina": 1,
        "cleaning": 0.0
      }, {
        "id": "RENAN",
        "name": "Villa  Pinot 101",
        "maxSize": 3,
        "basePrice": 50.0,
        "price": 50.0,
        "image": "RENAN",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 3,
        "singole": 0,
        "doppie": 0,
        "triple": 1,
        "bagno": 1,
        "wc": 0,
        "cucina": 1,
        "cleaning": 0.0
      }, {
        "id": "MAGNA4",
        "name": "Villa Magna 201",
        "maxSize": 4,
        "basePrice": 100.0,
        "price": 75.0,
        "image": "MAGNA4",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 4,
        "singole": 2,
        "doppie": 1,
        "triple": 0,
        "bagno": 1,
        "wc": 1,
        "cucina": 1,
        "cleaning": 0.0
      },  {
        "id": "MAGNA8",
        "name": "Villa Magna 202",
        "maxSize": 8,
        "basePrice": 150.0,
        "price": 95.0,
        "image": "MAGNA8",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 8,
        "singole": 0,
        "doppie": 4,
        "triple": 0,
        "bagno": 2,
        "wc": 1,
        "cucina": 1,
        "cleaning": 0.0
      }, {
        "id": "PARVA3",
        "name": "Villa Pinot 111",
        "maxSize": 1,
        "basePrice": 250.0,
        "price": 500.0,
        "image": "PARVA3",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 3,
        "singole": 0,
        "doppie": 1,
        "triple": 0,
        "bagno": 1,
        "wc": 0,
        "cucina": 1,
        "cleaning": 0.0
      }, {
        "id": "PARVA4",
        "name": "Villa Pinot 112",
        "maxSize": 2,
        "basePrice": 250.0,
        "price": 500.0,
        "image": "PARVA4",
        "language": "ita",
        "shortDesc": "",
        "longDesc": "",
        "posti": 4,
        "singole": 0,
        "doppie": 2,
        "triple": 0,
        "bagno": 1,
        "wc": 0,
        "cucina": 1,
        "cleaning": 0.0
      }]
    }
  },
  i18n: {
    fallbackLocale: 'it', // default lang,
    messages: {
      it: {
        hospitality: 'Ospitalità',
        info: 'Per richiedere informazioni sulla disponibilità mandare un email a',
        search: 'Cerca Disponibilità'
      },
      en: {
        hospitality: 'Hospitality',
        info: 'For information on availability, send an email to',
        search: 'Search for Availability'
      }
    }
  },
  updated: function () {
    window.addEventListener('resize', this.getPageHeight)
  },
  mounted: function () {
    this.getCamere()
    window.scroll(0, 0)
    this.form.dateFrom= moment().add(1,'days')._d
    this.setDateTo()
    //this.ricerca('form')
    //if (this.$route.params.dateTo && this.$route.params.dateFrom && this.$route.params.people) this.ricerca('form')
    if (localStorage.getItem('dateTo') && localStorage.getItem('dateFrom') && localStorage.getItem('people')) this.getCamereAgain()
  },
  methods: {
    getParameters: function(nomeParametro) {
      return localStorage.getItem(nomeParametro) ? localStorage.getItem(nomeParametro) : this.form[nomeParametro]
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    getCamere: function () {
      let orderedCamere = this.listCamere.sort((a, b) => {
        let orderA = this.ordineCamere.indexOf(a.id);
        let orderB = this.ordineCamere.indexOf(b.id);
        return orderA - orderB;
      });

      this.$set(this, 'camere', orderedCamere);
    },
    // serve per tenere traccia della richiesta quando si aggiorna la pagina e si torna indietro
    getCamereAgain: function () {
      this.$set(this, 'camere', this.listCamere)
    },
    formatDate: function (date) {
      let formatIn = 'DD-MM-YYYY'
      let formatOut = 'YYYY-MM-DD'
      if (date !== undefined && date !== '') return moment(date, formatIn).format(formatOut)
      else return ''
    },
    setDateTo: function () {
      var _this = this
      if (this.form.dateTo === '' || moment(this.form.dateFrom, 'DD-MM-YYYY').isAfter(moment(this.form.dateTo, 'DD-MM-YYYY'))) {
        this.form.dateTo = moment(this.form.dateFrom, 'DD-MM-YYYY').add(2, 'days').toDate()
      }
      this.pickerOptions2 = {
        disabledDate(time) {
          return time.getTime() < _this.form.dateFrom
        }
      }
    },
    checkRouterParams: function () {
      if (this.$route.params.dateTo) return this.$route.params.dateTo
      else return ''
    }
  }
}
</script>

<style lang="less">
@import "../assets/less/variabili.less";
@import "../assets/less/font.less";

#checkIn, #checkOut {
  width: 140px;
}

#ospitalita {
  input[type=number] {
    text-align: center;
    font-weight: normal;
    outline: none;
    padding: 3px;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: initial;
    margin: 0;
  }
  background-color: @lightBlack;
  .roomslider {
    .agile {
      .agile__track {
      }
    }
  }
  #scatola {
    border-bottom: 1px solid darkgray;
    .indirizzo {
      padding-left: 125px;
      padding-top: 20px;
      letter-spacing: 1px;
      .set-font(@size: 13px)
    }
    .elemento {
      padding-left: 110px;
      padding-right: 110px;
      margin-right: 0px;
      margin-left: 0px;
      .formCamere {
        background-color: @darkGray;
        border-radius: 6px;
        margin-top: 10px;
        padding: 15px;
        padding-top: 25px;
        padding-right: 0;
        padding-bottom: 0;
        margin-bottom: 42px;
        #cerca {
          .botton {
            width: 240px;
            background-color: @myOrange;
            border-color: @borderOrange;
            margin: auto;
            text-align: center;
            display: inherit;
            letter-spacing: 1px;
            .set-font()
          }
        }
        .el-form-item {
          padding-left: 20px;
          .el-form-item__label {
            .set-font(@size: 16px);
          }
        }
      }
      .nrOspitiMq {
        display: inline-block;
        padding-left: 25px;
        vertical-align: baseline;
        padding-right: 10px;
        .inputPersone {
          text-align: right;
          vertical-align: middle;
          float: left;
          .set-font(@size: 16px);
          line-height: 40px;
          padding: 0 12px 0 0;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
        }
      }
      .bottone {
        text-align: center;
        padding-bottom: 30px;
        width: 230px;
        display: inline-block;
        vertical-align: baseline;
        .info {
          border: 1px solid @lightGold;
          padding: 5px;
          letter-spacing: 1px;
          .set-font(@size: 22px, @color: @lightGold)
        }
      }
    }
    .box {
      border: 1px solid white;
      padding-left: 0px;
      width: 85%;
      margin: 40px auto;
      .foto {
        padding-left: 0px;
      }
      .titoloevento {
        padding-left: 80px;
        padding-top: 40px;
        .set-font-title();
        .icon {
          padding-left: 20px;
        }
      }
      .descrizioneevento {
        padding-top: 20px;
        padding-bottom: 20px;
        .set-font();
        display: flex;
        flex-wrap: wrap;
        .dettagli{
        }
      }
      .iconcamera{
        width: 40px;
        height: 35px;
        margin-right: 20px;
      }
      .iconservice{
        width: 40px;
        height: 35px;
      }
      .bottone {
        width: 230px;
        background-color: @myOrange;
        border-color: @borderOrange;
        margin: auto;
        text-align: center;
        display: inherit;
        letter-spacing: 1px;
        margin-bottom: 20px;
        margin-top: 30px;
        .set-font()
      }
    }
  }
}

@media (max-width: 767px) {
  #ospitalita {
    .roomslider {
      .agile {
        .agile__track {
        }
      }
    }
    #scatola {
      .indirizzo {
        padding-left: 20px;
        padding-top: 15px;
        letter-spacing: 1px;
        .set-font(@size: 12px)
      }
      .elemento {
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 0px;
        .formCamere {
          padding-left: 5px;
          margin-bottom: 10px;
          #cerca {
            text-align: center;
            width: 100%;
          }
          .el-form-item {
            padding-left: 0px;
            .el-form-item__label {
              // .set-font(@size: 20px)
            }
          }
          .el-input__inner {
            width: 135px;
          }
        }
        .nrOspitiMq {
          display: block;
          padding-left: 10px;
          padding-bottom: 25px;
          .inputPersone {
          }
        }
        .bottone {
          .info {
          }
        }
      }
      .box {
        padding-right: 2px;
        .foto {
          padding-right: 0px;
        }
        .titoloevento {
          padding-left: 6px;
          padding-right: 2px;
          .set-font-title(@size: 22px);
          .icon {
            padding-left: 5px;
            width: 16%;
          }
        }
        .descrizioneevento {
          padding-top: 20px;
          padding-bottom: 50px;
          .set-font(@size: 14px)
        }
        .iconcamera{
          width: 35px;
          height: 30px;
          margin-right: 5px;
        }
        .bottone {
          padding-left: 0px;
          padding-right: 0px;
          .info {
            .set-font(@size: 13px, @color: @lightGold)
          }
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  #ospitalita {
    .roomslider {
      .agile {
        .agile__track {
        }
      }
    }
    #scatola {
      .indirizzo {
      }
      .elemento {
        .formCamere {
          .el-form-item {
            .el-form-item__label {
            }
          }
        }
        .nrOspitiMq {
          .inputPersone {
          }
        }
        .bottone {
          .info {
          }
        }
      }
      .box {
        padding-right: 0px;
        .foto {
          padding-right: 0px;
        }
        .titoloevento {
          padding-left: 10px;
          .icon {
            padding-left: 20px;
          }
        }
        .descrizioneevento {
          padding-top: 20px;
          padding-bottom: 20px;
          .set-font()
        }
        .bottone {
          padding-left: 0px;
          .info {
          }
        }
      }
    }
  }
}

@media (min-width: 1025px) and (max-width: 1366px) {
  #ospitalita {
    .roomslider {
      .agile {
        .agile__track {
        }
      }
    }
    #scatola {
      .indirizzo {
      }
      .elemento {
        .formCamere {
          .el-form-item {
            .el-form-item__label {
            }
          }
        }
        .nrOspitiMq {
          .inputPersone {
          }
        }
        .bottone {
          .info {
          }
        }
      }
      .box {
        padding-right: 0px;
        .foto {
          padding-right: 0px;
        }
        .titoloevento {
          padding-left: 10px;
          .icon {
            padding-left: 20px;
          }
        }
        .descrizioneevento {
          padding-top: 20px;
          padding-bottom: 5px;
          .set-font()
        }
        .bottone {
          padding-left: 0px;
          margin-top: 20px;
          .info {
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ospitalita.vue